import { Component } from '@angular/core';
import { LoaderService, ProcessStatus } from './services/loader.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { version } from '../../package.json';
import { ProcessStatusEnum } from 'src/app/services/loader.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {

  softwareVersion = version;
  ProcessStatusEnum = ProcessStatusEnum;
  processStatus: ProcessStatus;

  constructor(private loaderService: LoaderService, private snackBar: MatSnackBar, ) {

  }

  ngOnInit(): void {
    /**
    * Sottoscrizione a eventi asincorni che necessitano attesa (attivazione dello spinner)
    */
    this.loaderService.processStatus.subscribe((processStatus: ProcessStatus) => {
      this.processStatus = processStatus;
      if (this.processStatus.message) {
        this.snackBar.open(processStatus.message, null, {
          duration: 3000,
          panelClass: processStatus.toastClassName,
          horizontalPosition: "left"
        });
      }
    })
  }

}
